import { REWARD_ANIMATION_DURATION } from '../../public/constants/constants';

export function animateReward(
  from: number,
  to: number,
  setter: (value: React.SetStateAction<number>) => void,
  callback?: () => void,
): void {
  let currentValue = from;
  setter(currentValue);
  const milliseconds = REWARD_ANIMATION_DURATION / (to - from);
  const interval = setInterval(() => {
    ++currentValue;
    setter(currentValue);
    if (currentValue === to) {
      clearInterval(interval);
      if (callback) {
        callback();
      }
    }
  }, milliseconds);
}
